// eslint-disable-next-line
// import React, { useState } from "react";
import React, { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom';

// import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";

// import theme from "./theme/theme";
// pre login pages
import Home from './pages/home/home';
import About from './pages/home/about';
import Login from "./pages/auth/Login";
import Register from "./pages/auth/Register";
import Pricing from './pages/statics/PricingPage';

// main pages
import Dashboard from './pages/dashboard/Dashboard';
// import MainPage from './pages/statics/MainPage';

import LinkedInCallback from "./pages/auth/LinkedInCallback";
import LinkedInCompleteProfile from "./pages/auth/LinkedInCompleteProfile";
import Profile from './pages/profile/Profile';
// import Searches from './pages/dashboard/Searches';
// import List from './pages/dashboard/List';
  // import Team from './pages/dashboard/Team';
import MainSearch from './pages/search/MainSearch';
// import Pricing from './pages/statics/pricing';
import Lists from './pages/lists/Lists';
import SharedListView from './pages/lists/SharedListView';
import ListView from './pages/lists/ListView';
import Searches from './pages/searches/Searches';

// admin pages
import AdminLogin from './pages/admin/pages/login';
import AdminDashboard from './pages/admin/pages/dashboard';
import AdminDashboardAdmins from './pages/admin/pages/admins';
import RegisteredUsers from './pages/admin/pages/registeredusers';
import UserProfileDetails from './pages/admin/pages/UserProfileDetails'; 
import Profiles from './pages/admin/pages/profiles';
import ProfileDetails from './pages/admin/pages/ProfileDetails';
import Orders from './pages/admin/pages/Orders';
import OrderDetails from './pages/admin/pages/OrderDetails';
import Teams from './pages/teams/teams';
import TeamsView from './pages/teams/TeamsView';
import PublicView from './pages/lists/PublicView';
import PublicSignup from './pages/auth/PublicSignup';
import TeamsRegister from './pages/teams/TeamsRegister';
import BlockedDomains from "./pages/admin/pages/BlockedDomains";
import AutoPilot from './pages/autopilot/AutoPilot';
import WorkflowContainer from './pages/workflow/WorkflowContainer';
import AgenticPage from './pages/agentic/AgenticPage';
import IcpSearchPage from './pages/icp/IcpSearchPage';

import SearchQueriesPage from './pages/admin/pages/SearchQueriesPage';
import PrivacyPolicy from './pages/home/privacy';
import Tnc from './pages/home/tnc';
import Faq from './pages/home/faq';

import PublicProfileView from './pages/lists/PublicProfileView';

// Component to track page views for Google Analytics
function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', 'G-0WCMLQQDH4', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);

  return null;
}

function App() {
  // Initialize Tawk.to chat globally
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const script = document.createElement("script");
      script.async = true;
      script.src = 'https://embed.tawk.to/64f4b4c5a91e863a5c1162d7/1h9du49kf';
      script.charset = 'UTF-8';
      script.setAttribute('crossorigin', '*');
      document.head.appendChild(script);
    }
  }, []);

  return (
    // <ThemeProvider theme={theme}>
        <BrowserRouter>
          <PageViewTracker />
          <CssBaseline />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/linkedin-callback" element={<LinkedInCallback />} />
            <Route path="/linkedin-complete-profile" element={<LinkedInCompleteProfile />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/account" element={<Profile />} />
            <Route path="/search" element={<MainSearch />} />
            <Route path="/searches" element={<Searches />} />
            <Route path="/icp-search" element={<IcpSearchPage />} />
            <Route path="/list/:listId" element={<ListView />} />
            <Route path="/teams" element={<Teams />} />
            <Route path="/team/:teamId" element={<TeamsView />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/lists" element={<Lists />} />
            <Route path="/autopilot" element={<AutoPilot />} />
            <Route path="/workflow/*" element={<WorkflowContainer />} />
            <Route path="/agentic" element={<AgenticPage />} />
            <Route path="/shared-list/:listId" element={<SharedListView />} />
            <Route path="/view/list/:listId" element={<PublicView />} />
            <Route path="/public-signup" element={<PublicSignup />} />
            <Route path="/teams/register/:encodedEmail" element={<TeamsRegister />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/tnc" element={<Tnc />} />
            <Route path="/faq" element={<Faq />} />
            {/* admin routes */}
            <Route path="/admin/profiles" element={<Profiles />} />
            <Route path="/admin/orders/:id" element={<OrderDetails />} />
            <Route path="/admin/profiledetails/:id" element={<ProfileDetails />} />
            <Route path="/admin/registered-users" element={<RegisteredUsers />} />
            <Route path="/admin/userprofiledetails/:userId" element={<UserProfileDetails />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/orders" element={<Orders />} />
            <Route path="/admin/search" element={<SearchQueriesPage />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/admin/admins" element={<AdminDashboardAdmins />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/tnc" element={<Tnc />} />
            <Route path="/faq" element={<Faq />} />
            <Route  path="/admin/blocked-domains" element={<BlockedDomains />}/>
            <Route path="/public/profile/:token" element={<PublicProfileView />} />

            <Route path="/home/about" element={<About />} />
          </Routes>
        </BrowserRouter>
    //  </ThemeProvider>
  )
}

export default App;